import { atom } from 'recoil';
import Employee from '../../interfaces/api/Employee';

export default atom({
  key: 'employees',
  default: {} as { [key: string]: Employee },
});
